import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const colaba: AreaConfig = {
  name: 'Colaba & South Mumbai',
  slug: 'colaba-south-mumbai',
  tagline: 'Premium Doorstep iPhone Repair in Colaba & South Mumbai',
  description: 'South Mumbai\'s most trusted doorstep mobile repair service. From Colaba to Malabar Hill, Breach Candy to Marine Drive — minto brings certified technicians with OEM parts to your home. No need to visit Unicorn or Maple service centers.',
  localities: [
    'Colaba', 'Cuffe Parade', 'Nariman Point', 'Churchgate', 'Marine Drive',
    'Malabar Hill', 'Breach Candy', 'Napean Sea Road', 'Pedder Road',
    'Altamount Road', 'Kemps Corner', 'Tardeo', 'Walkeshwar', 'Fort',
    'Ballard Estate',
  ],
  zones: [
    {
      name: 'Colaba & Cuffe Parade',
      line: 'Harbour Line',
      station: 'Churchgate / CST Station',
      localities: ['Colaba', 'Cuffe Parade', 'Navy Nagar', 'Afghan Church', 'Colaba Causeway', 'Sassoon Dock'],
      desc: 'The southern tip of Mumbai — elite residential complexes and naval quarters. Our technicians provide discreet, professional doorstep service.',
    },
    {
      name: 'Malabar Hill & Breach Candy',
      line: 'Western Line',
      station: 'Grant Road / Charni Road',
      localities: ['Malabar Hill', 'Breach Candy', 'Walkeshwar', 'Napean Sea Road', 'Altamount Road', 'Pedder Road', 'Kemps Corner', 'Hanging Gardens area'],
      desc: 'Mumbai\'s most premium residential address. We visit ultra-luxury apartments and heritage buildings for all iPhone and smartphone repairs.',
    },
    {
      name: 'Marine Drive & Churchgate',
      line: 'Western Line',
      station: 'Churchgate / Marine Lines',
      localities: ['Marine Drive', 'Nariman Point', 'Churchgate', 'Fort', 'Ballard Estate', 'Marine Lines', 'Girgaon Chowpatty'],
      desc: 'Corporate offices at Nariman Point and residences along Marine Drive. Quick 30-minute arrival for phone repairs at your office or home.',
    },
  ],
  seo: {
    title: 'iPhone Repair in Colaba & South Mumbai | Apple Store Alternative | minto',
    description: 'Premium doorstep iPhone repair in Colaba, Malabar Hill, Marine Drive, Nariman Point. OEM battery replacement, screen repair. Alternative to Unicorn & Maple service centers. 6-month warranty. 30-min arrival.',
    keywords: 'mobile repair Colaba, iPhone repair South Mumbai, phone repair Malabar Hill, battery replacement Marine Drive, screen repair Nariman Point, doorstep iPhone repair Colaba, mobile repair Breach Candy, phone repair Cuffe Parade, iPhone service Churchgate, Unicorn service center alternative',
  },
  faqs: [
    {
      q: 'How is minto different from Unicorn or Maple service centers?',
      a: 'We use the same OEM-quality parts as authorized centers but we come to YOUR location. No travel, no appointment slots, no 2-3 day wait. Most repairs done in 30-60 minutes at your doorstep with 6-month warranty.',
    },
    {
      q: 'Do you cover Malabar Hill and Breach Candy?',
      a: 'Yes! We cover all of South Mumbai including Malabar Hill, Breach Candy, Napean Sea Road, Altamount Road, and Pedder Road. Our technicians are experienced in servicing premium high-rise residences.',
    },
    {
      q: 'Can you come to my office at Nariman Point?',
      a: 'Absolutely. Nariman Point and Fort area corporate offices are among our regular service locations. We come to your reception or cabin and repair the phone while you work.',
    },
    {
      q: 'Do you replace iPhone batteries with genuine Apple parts?',
      a: 'We use OEM-equivalent batteries that match Apple\'s specifications. Your iPhone will show normal battery health with no \"Unknown Part\" warning — at 40-50% lower cost than the Apple Store.',
    },
    {
      q: 'What\'s the warranty on repairs in South Mumbai?',
      a: 'Battery replacements come with 180 days (6 months) warranty. Screen repairs have 90 days warranty. If anything goes wrong within the warranty period, we fix it free.',
    },
  ],
};

const ColabaPage: React.FC = () => <AreaLandingPage area={colaba} />;
export default ColabaPage;
